import type * as Schema from "./schema";
import { Article, articleFields } from "./article";

export type HowTo = Article<Schema.HowTo>;

export const howToFields = articleFields;

export const howToTypeLiteral: `"${Schema.HowTo["_type"]}"` = '"howTo"';
